export interface PainPoint {
  title: string
  body: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 DOUZE DÉRIVATIONS… SANS SAVOIR PAR OÙ COMMENCER',
    body: 'Le tracé sort de l’appareil, mais sans ordre de lecture, l’œil se promène au hasard et les détails importants passent inaperçus.',
  },
  {
    title: '🔍 ARTEFACT OU VRAIE ARYTHMIE ?',
    body: 'Un patient qui bouge, une électrode décollée, un rythme irrégulier : sans repères clairs, le doute s’installe devant le scope.',
  },
  {
    title: '⚠️ APPELER OU ATTENDRE ?',
    body: 'Un sus-décalage, un QT long, une bradycardie : on hésite au moment d’alerter, et on ne sait pas toujours quoi dire au médecin.',
  },
  {
    title: '📚 DES SUPPORTS DISPERSÉS PARTOUT',
    body: 'Cours d’IFSI, notes de stage, protocoles du service : l’information existe, mais jamais au moment où vous êtes devant le tracé.',
  },
]
